import { render, staticRenderFns } from "./LocationSalesTable.vue?vue&type=template&id=54acc9e0&"
import script from "./LocationSalesTable.vue?vue&type=script&lang=js&"
export * from "./LocationSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports